import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Maintenance } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogEditMaintenanceComponent, MaintenanceDialogData } from './dialog-maintenances.component';

@Injectable({
  providedIn: 'root'
})
export class DialogMaintenancesService {
  constructor(
    private readonly matDialog: MatDialog,
    private readonly maintenancesApi: MaintenancesApi,
    private readonly authenticationService: AuthenticationService,
    private readonly fuseProgressBarService: FuseProgressBarService,
  ) {}

  public async open(maintenanceId: string): Promise<boolean> {
    const maintenance = await this.getMaintenance(maintenanceId);
    return this.matDialog.open<DialogEditMaintenanceComponent, MaintenanceDialogData, boolean>(DialogEditMaintenanceComponent, {
      panelClass: 'dialog-edit-maintenance',
      autoFocus: false,
      data: {
        maintenance,
        isViewMode: !this.authenticationService.hasPermission('maintenances-edit'),
      }
    }).afterClosed()
      .toPromise();
  }

  public async getMaintenance(maintenanceId: string): Promise<Maintenance> {
    this.fuseProgressBarService.show();
    const result = await this.maintenancesApi.searchOne(maintenanceId).toPromise();
    this.fuseProgressBarService.hide();
    return result;
  }
}
